import LoyaltyNotEnrolled from './loyalty-not-enrolled.default';

export default LoyaltyNotEnrolled;
